import React from "react";
import { position, PositionProps } from "styled-system";
import { Box } from "@bca/ui-library";
import styled from "styled-components";

const VrmBox = styled(Box)`
  border-left: 7px solid #2196f3;
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 9px 0 rgba(65, 65, 65, 0.1);
  text-transform: uppercase;
  ${position}
`;

interface VrmProps extends PositionProps {
  vrm: string | string[];
}

function Vrm({ vrm, ...props }: VrmProps) {
  return (
    <VrmBox
      minWidth={84}
      minHeight={25}
      padding="6px 10px"
      mr="8px"
      mt={[2, 3]}
      backgroundColor="primary-white"
      {...props}
    >
      {vrm}
    </VrmBox>
  );
}

export default Vrm;
